import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const FileNameInput = React.forwardRef(
  ({ value, onChange, dragEnter, hasResourceUpdateHighlight, placeholder, readOnly, onFocus }, ref) => (
    <input
      id="file-name-field"
      type="text"
      ref={ref}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={clsx(dragEnter && 'drag-enter', hasResourceUpdateHighlight && 'updateHighlight')}
      placeholder={placeholder}
      readOnly={readOnly}
      onFocus={onFocus}
    />
  )
);

FileNameInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  dragEnter: PropTypes.bool,
  hasResourceUpdateHighlight: PropTypes.bool,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  onFocus: PropTypes.func,
};

FileNameInput.defaultProps = {
  value: '',
  onChange: () => {},
  dragEnter: false,
  hasResourceUpdateHighlight: false,
  placeholder: 'Drag or upload an image',
  readOnly: true,
  onFocus: () => {},
};

